// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__3LKkx","dragIcon":"SortableItem_dragIcon__QHq6q","disabled":"SortableItem_disabled__2-leG"};